import type { ModelDescriptor } from '../types';

interface ModelChipRowProps {
  models: ModelDescriptor[];
  selectedKey: string;
  onSelect: (key: string) => void;
  disabled?: boolean;
}

export function ModelChipRow({ models, selectedKey, onSelect, disabled }: ModelChipRowProps) {
  if (models.length === 0) {
    return (
      <p className="rounded-md bg-gray-800 px-4 py-3 text-sm text-gray-400">
        No models enabled. Configure providers in the API settings.
      </p>
    );
  }

  return (
    <div className="flex flex-wrap gap-2" role="radiogroup" data-testid="model-chip-row">
      {models.map((m) => {
        const isSelected = m.key === selectedKey;
        return (
          <button
            key={m.key}
            type="button"
            role="radio"
            aria-checked={isSelected}
            onClick={() => onSelect(m.key)}
            disabled={disabled}
            data-testid={`chip-${m.key}`}
            data-selected={isSelected}
            className={[
              'rounded-full border px-3 py-1.5 text-xs font-medium transition-colors disabled:opacity-50',
              isSelected
                ? 'border-blue-400 bg-blue-600/30 text-blue-100'
                : 'border-gray-700 bg-gray-800 text-gray-300 hover:border-gray-600',
            ].join(' ')}
            title={`$${m.estimated_cost_usd_per_image.toFixed(4)} / image`}
          >
            {m.display_name}
          </button>
        );
      })}
    </div>
  );
}
